import React, { useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Divider } from "@material-ui/core";
import Search from "../../components/common/Search";
import cn from "classnames";
import styles from "./Fota.module.scss";

export default function UpgradeFilter(props) {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [filterOpen, setFilterOpen] = useState(props.open);
  const [zoneDrawerOpen, setZoneDrawerOpen] = useState(false);
  const [stateDrawerOpen, setStateDrawerOpen] = useState(false);
  const [cityDrawerOpen, setCityDrawerOpen] = useState(false);
  const [siteDrawerOpen, setSiteDrawerOpen] = useState(false);
  const [statusDrawerOpen, setStatusDrawerOpen] = useState(false);
  const [makeDrawerOpen, setMakeDrawerOpen] = useState(false);
  const [modelDrawerOpen, setModelDrawerOpen] = useState(false);
  const [firmwareDrawerOpen, setFirmwareDrawerOpen] = useState(false);

  const handleSubDrawerOpen = (drawerType) => {
    switch (drawerType) {
      case "zone":
        setMakeDrawerOpen(false);
        setModelDrawerOpen(false);
        setFirmwareDrawerOpen(false);
        setZoneDrawerOpen(true);
        setStateDrawerOpen(false);
        setCityDrawerOpen(false);
        setSiteDrawerOpen(false);
        setStatusDrawerOpen(false);
        break;
      case "state":
        setMakeDrawerOpen(false);
        setModelDrawerOpen(false);
        setFirmwareDrawerOpen(false);
        setZoneDrawerOpen(false);
        setStateDrawerOpen(true);
        setCityDrawerOpen(false);
        setSiteDrawerOpen(false);
        setStatusDrawerOpen(false);
        break;
      case "city":
        setMakeDrawerOpen(false);
        setModelDrawerOpen(false);
        setFirmwareDrawerOpen(false);
        setZoneDrawerOpen(false);
        setStateDrawerOpen(false);
        setCityDrawerOpen(true);
        setSiteDrawerOpen(false);
        setStatusDrawerOpen(false);
        break;
      case "site":
        setMakeDrawerOpen(false);
        setModelDrawerOpen(false);
        setFirmwareDrawerOpen(false);
        setZoneDrawerOpen(false);
        setStateDrawerOpen(false);
        setCityDrawerOpen(false);
        setSiteDrawerOpen(true);
        setStatusDrawerOpen(false);
        break;
      case "status":
        setMakeDrawerOpen(false);
        setModelDrawerOpen(false);
        setFirmwareDrawerOpen(false);
        setZoneDrawerOpen(false);
        setStateDrawerOpen(false);
        setCityDrawerOpen(false);
        setSiteDrawerOpen(false);
        setStatusDrawerOpen(true);
        break;
      case "make":
        setMakeDrawerOpen(true);
        setModelDrawerOpen(false);
        setFirmwareDrawerOpen(false);
        setZoneDrawerOpen(false);
        setStateDrawerOpen(false);
        setCityDrawerOpen(false);
        setSiteDrawerOpen(false);
        setStatusDrawerOpen(false);
        break;
      case "model":
        setModelDrawerOpen(true);
        setMakeDrawerOpen(false);
        setFirmwareDrawerOpen(false);
        setZoneDrawerOpen(false);
        setStateDrawerOpen(false);
        setCityDrawerOpen(false);
        setSiteDrawerOpen(false);
        setStatusDrawerOpen(false);
        break;
      case "firmware":
        setFirmwareDrawerOpen(true);
        setModelDrawerOpen(false);
        setMakeDrawerOpen(false);
        setZoneDrawerOpen(false);
        setStateDrawerOpen(false);
        setCityDrawerOpen(false);
        setSiteDrawerOpen(false);
        setStatusDrawerOpen(false);
        break;
      default:
        break;
    }
  };

  const handleSubDrawerClose = (drawerType) => {
    switch (drawerType) {
      case "make":
        setMakeDrawerOpen(false);
        break;
      case "model":
        setModelDrawerOpen(false);
        break;
      case "firmware":
        setFirmwareDrawerOpen(false);
        break;
      case "site":
        setSiteDrawerOpen(false);
        break;
      case "zone":
        setZoneDrawerOpen(false);
        break;
      case "city":
        setCityDrawerOpen(false);
        break;
      case "status":
        setStatusDrawerOpen(false);
        break;
      case "state":
        setStateDrawerOpen(false);
        break;

      default:
        break;
    }

    setDrawerOpen(true);
  };

  return (
    <div>
      {/* Main Drawer */}
      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        direction="left"
        style={{ width: 300, zIndex: "999" }}
      >
        <div className={cn(styles.filter_heading)}>
          <h1>Filters</h1>
          <img
            src={require("assets/CloseBlueButton.svg").default}
            style={{ height: "25px", width: "13px" }}
            onClick={() => setDrawerOpen(false)}
            alt="Close Drawer"
          ></img>
        </div>
        <div>
          <List>
            <ListItemButton onClick={() => handleSubDrawerOpen("zone")}>
              <ListItemText primary="Zones" />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItemButton>
            <Divider variant="middle" />
            <ListItemButton onClick={() => handleSubDrawerOpen("state")}>
              <ListItemText primary="State" />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItemButton>
            <Divider variant="middle" />
            <ListItemButton onClick={() => handleSubDrawerOpen("city")}>
              <ListItemText primary="City" />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItemButton>
            <Divider variant="middle" />
            <ListItemButton onClick={() => handleSubDrawerOpen("site")}>
              <ListItemText primary="Site" />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItemButton>
            <Divider variant="middle" />
            {/* Make */}
            <ListItemButton onClick={() => handleSubDrawerOpen("make")}>
              <ListItemText primary="Make" />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItemButton>
            <Divider variant="middle" />

            {/* Model */}
            <ListItemButton onClick={() => handleSubDrawerOpen("model")}>
              <ListItemText primary="Model" />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItemButton>
            <Divider variant="middle" />

            {/* Firmware Version */}
            <ListItemButton onClick={() => handleSubDrawerOpen("firmware")}>
              <ListItemText primary="Firmware Version" />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItemButton>
            <Divider variant="middle" />
            <ListItemButton onClick={() => handleSubDrawerOpen("status")}>
              <ListItemText primary="Status" />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItemButton>
            <Divider variant="middle" />
          </List>
          <div style={{ position: "absolute", bottom: "2%", left: "10%" }}>
            <button
              className={styles.button_flex1}
              onClick={() => {
                setDrawerOpen(false);
                setFilterOpen(!filterOpen);
              }}
            >
              Clear All
            </button>
            <button className={styles.button_flex2}>Apply Filter</button>
          </div>
          {makeDrawerOpen && (
            <div className={styles.subDrawer}>
              <div className={styles.subDrawer_heading}>
                <div className={styles.subDrawer_item1}>
                  <img
                    src={require("assets/blueLeftArrow.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                    onClick={() => handleSubDrawerClose("make")}
                  ></img>
                  <p>Select Make</p>
                </div>
                <div className={styles.subDrawer_item2}>
                  <img
                    src={require("assets/ic_reset.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                  ></img>
                  <p>Reset</p>
                </div>
              </div>
              <div style={{ margin: "0px 20px" }}>
                <Search
                  className={cn(styles.search_block, styles.search_layout)}
                  placeholder={"Search Make"}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Make1" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Make2" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Make3" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Make4" />
                </ListItemButton>
                <Divider variant="middle" />
              </div>
            </div>
          )}
          {modelDrawerOpen && (
            <div className={styles.subDrawer}>
              <div className={styles.subDrawer_heading}>
                <div className={styles.subDrawer_item1}>
                  <img
                    src={require("assets/blueLeftArrow.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                    onClick={() => handleSubDrawerClose("model")}
                  ></img>
                  <p>Select Model</p>
                </div>
                <div className={styles.subDrawer_item2}>
                  <img
                    src={require("assets/ic_reset.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                  ></img>
                  <p>Reset</p>
                </div>
              </div>
              <div style={{ margin: "0px 20px" }}>
                <Search
                  className={cn(styles.search_block, styles.search_layout)}
                  placeholder={"Search Model"}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Model1" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Model2" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Model3" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Model4" />
                </ListItemButton>
                <Divider variant="middle" />
              </div>
            </div>
          )}
          {firmwareDrawerOpen && (
            <div className={styles.subDrawer}>
              <div className={styles.subDrawer_heading}>
                <div className={styles.subDrawer_item1}>
                  <img
                    src={require("assets/blueLeftArrow.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                    onClick={() => handleSubDrawerClose("firmware")}
                  ></img>
                  <p>Select Firmware Version</p>
                </div>
                <div className={styles.subDrawer_item2}>
                  <img
                    src={require("assets/ic_reset.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                  ></img>
                  <p>Reset</p>
                </div>
              </div>
              <div style={{ margin: "0px 20px" }}>
                <Search
                  className={cn(styles.search_block, styles.search_layout)}
                  placeholder={"Search Firmware Version"}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="V 2.5" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="V 2.0" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="V 1.5" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="V 1.5" />
                </ListItemButton>
                <Divider variant="middle" />
              </div>
            </div>
          )}
            {zoneDrawerOpen && (
            <div className={styles.subDrawer}>
              <div className={styles.subDrawer_heading}>
                <div className={styles.subDrawer_item1}>
                  <img
                    src={require("assets/blueLeftArrow.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                    onClick={() => handleSubDrawerClose("zone")}
                  ></img>
                  <p>Select Zone</p>
                </div>
                <div className={styles.subDrawer_item2}>
                  <img
                    src={require("assets/ic_reset.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                  ></img>
                  <p>Reset</p>
                </div>
              </div>
              <div style={{ margin: "0px 20px" }}>
                <Search
                  className={cn(styles.search_block, styles.search_layout)}
                  placeholder={"Search Zone"}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Zone1" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Zone2" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Zone3" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Zone4" />
                </ListItemButton>
                <Divider variant="middle" />
              </div>
            </div>
          )}
            {stateDrawerOpen && (
            <div className={styles.subDrawer}>
              <div className={styles.subDrawer_heading}>
                <div className={styles.subDrawer_item1}>
                  <img
                    src={require("assets/blueLeftArrow.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                    onClick={() => handleSubDrawerClose("state")}
                  ></img>
                  <p>Select States</p>
                </div>
                <div className={styles.subDrawer_item2}>
                  <img
                    src={require("assets/ic_reset.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                  ></img>
                  <p>Reset</p>
                </div>
              </div>
              <div style={{ margin: "0px 20px" }}>
                <Search
                  className={cn(styles.search_block, styles.search_layout)}
                  placeholder={"Search State"}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Andhra Pradesh" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Assam" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Bihar" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Goa" />
                </ListItemButton>
                <Divider variant="middle" />
              </div>
            </div>
          )}
            {cityDrawerOpen && (
            <div className={styles.subDrawer}>
              <div className={styles.subDrawer_heading}>
                <div className={styles.subDrawer_item1}>
                  <img
                    src={require("assets/blueLeftArrow.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                    onClick={() => handleSubDrawerClose("city")}
                  ></img>
                  <p>Select Cities</p>
                </div>
                <div className={styles.subDrawer_item2}>
                  <img
                    src={require("assets/ic_reset.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                  ></img>
                  <p>Reset</p>
                </div>
              </div>
              <div style={{ margin: "0px 20px" }}>
                <Search
                  className={cn(styles.search_block, styles.search_layout)}
                  placeholder={"Search City"}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Hyderbad" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Kurnool" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Bangalore" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Tirupati" />
                </ListItemButton>
                <Divider variant="middle" />
              </div>
            </div>
          )}
            {siteDrawerOpen && (
            <div className={styles.subDrawer}>
              <div className={styles.subDrawer_heading}>
                <div className={styles.subDrawer_item1}>
                  <img
                    src={require("assets/blueLeftArrow.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                    onClick={() => handleSubDrawerClose("site")}
                  ></img>
                  <p>Select Site</p>
                </div>
                <div className={styles.subDrawer_item2}>
                  <img
                    src={require("assets/ic_reset.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                  ></img>
                  <p>Reset</p>
                </div>
              </div>
              <div style={{ margin: "0px 20px" }}>
                <Search
                  className={cn(styles.search_block, styles.search_layout)}
                  placeholder={"Search by Site"}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Avana" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="TestSite1" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Ibbalur" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="TestSite2" />
                </ListItemButton>
                <Divider variant="middle" />
              </div>
            </div>
          )}
            {statusDrawerOpen && (
            <div className={styles.subDrawer}>
              <div className={styles.subDrawer_heading}>
                <div className={styles.subDrawer_item1}>
                  <img
                    src={require("assets/blueLeftArrow.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                    onClick={() => handleSubDrawerClose("status")}
                  ></img>
                  <p>Select status</p>
                </div>
                <div className={styles.subDrawer_item2}>
                  <img
                    src={require("assets/ic_reset.svg").default}
                    // style={{ height: "25px", width: "13px" }}
                  ></img>
                  <p>Reset</p>
                </div>
              </div>
              <div style={{ margin: "0px 20px" }}>
                <Search
                  className={cn(styles.search_block, styles.search_layout)}
                  placeholder={"Search Status"}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Online" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Offline" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="In Progress" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton>
                  <div style={{ margin: "-13px 20px 0px 0px" }}>
                    <input type="checkbox" /> {/* Add your checkbox here */}
                  </div>
                  <ListItemText primary="Up To Date" />
                </ListItemButton>
                <Divider variant="middle" />
              </div>
            </div>
          )}
          
        </div>
      </Drawer>
    </div>
  );
}
